import $ from 'jquery';
import {ensureCommentFormExists, scrollIntoView} from './comment-tools.ts';

export function initReviewFileComment() {
  $(document).on('click', 'a.review-file-comment', async (e) => {
    e.preventDefault();
    const diffBox = e.target.closest('.diff-file-box');

    // pick a line number that hasn't been used to avoid using an existing thread
    const newThreadCount = diffBox.querySelectorAll('.field.comment-code-cloud').length + 1;

    const result = await ensureCommentFormExists(diffBox, newThreadCount.toString());
    const editor = result.editor;
    await scrollIntoView(editor.container, {block: 'center'});
    editor.focus();
  });
}

export function initReviewPageComment() {
  $(document).on('click', 'a.review-page-comment', async (e) => {
    e.preventDefault();
    const parent = e.target.closest('.accordion-contents');

    // pick a line number that hasn't been used to avoid using an existing thread
    const newThreadCount = document.querySelectorAll('.comment-code-cloud').length + 1;

    const result = await ensureCommentFormExists(parent, newThreadCount.toString());
    const editor = result.editor;

    await scrollIntoView(editor.container, {block: 'center'});
    editor.focus();
  });
}
